export default __webpack_public_path__ + "static/media/logo_dark.bf64e173.png";